import { defineStore } from "pinia";
import {
  getLocalBusinessNextPage,
  getLocalBusiness,
  getAllRestaurantFood,
  getSpecificFood,
  getSpecificBusiness,
  addN,
  addP,
} from "@/config/use_cases/negocios";
import { useUserStore } from "./user";

export const useBusinessStore = defineStore("business", {
  state: () => ({
    userStore: useUserStore(),
    business_array: {} as Record<string, Array<Record<string, any>>>,
    business_list: [] as Array<Record<string, any>>,
    new_business_list: [] as Array<Record<string, any>>,
    business_object: {} as Record<string, any>,
    food_object: {} as Record<string, any>,
    food_key_value: {} as Record<string, any>,
  }),

  getters: {
    getAllBusinessArray: (state) => state.business_array,
    getAllBusinessList: (state) => state.business_array[state.userStore.getAddressesId],
    getNewBusinessList: (state) => state.new_business_list,
    getAllBusinessObject: (state) => state.business_object,
    getAllFoodObject: (state) => state.food_object,
    getAllFoodKeyValue: (state) => state.food_key_value,
  },

  actions: {
    _updateFood(info: any, full: boolean = false) {
      const business_id  = info.business_id;
      Object.assign(this.food_key_value, info.data.object);
      if(full) {
        this.food_object[business_id] = info.data.array;
      }
    },
    async getAllFoodByRestaurant(business_id: string) {
      const existingFood = this.food_object[business_id];
      if (existingFood) {
        return existingFood;
      }
      let data = await getAllRestaurantFood(business_id);
      this._updateFood({business_id, data}, true);
      return data.array;
    },
    async getSpecificFoodById(
      food_id: string,
      business_id: string,
    ) {
      const food = this.food_key_value[food_id];
      if (food) {
        return food;
      }
      const data = await getSpecificFood(food_id, business_id);
      if(!data) return;
      this._updateFood({business_id, data: {object: data} });
      return data;
    },
    async getSpecificBusinessById(business_id: string) {
      const business_loaded = this.business_object[business_id];
      if (business_loaded) {
        return business_loaded;
      }
      const busines = await getSpecificBusiness(business_id);
      if (busines?.id) {
        this.business_object[busines.id] = busines;
      }
        return busines;
    },
    async getBusiness(is_change: boolean = false) {
      const address = this.userStore.getAddress;
      const address_id = this.userStore.getAddressesId;
      if(!this.business_array[address_id]) {
        this.business_array[address_id] = [];
      }
      const location = address.g.geopoint;
      const business = this.business_array[address_id];
      if (business?.length && is_change) {
        return business;
      }
      const page = await getLocalBusiness(location, address_id);
      const date_timestamp = new Date();
      const current_date = Math.floor(date_timestamp.getTime() / 1000);
      page.forEach((business: any) => {
        this.business_object[business.id] = business;
        this.business_array[address_id].push(business);
        this.business_list.push(business);
        let diferencia = current_date - business.creation_date.seconds;
        if (diferencia < 604800) {
          this.new_business_list.push(business);
        } 
      });
      return page;
    },

    // async getAllFoodByRestaurant(id_restaurant: string) {
    //   const city_id = localStorage.getItem("city_id") || "";

    //   const food_city = this.food_array[city_id];
    //   if (food_city) {
    //     const food = food_city[id_restaurant];
    //     if (food?.length) {
    //       return food;
    //     }
    //   }

    //   const data = await getAllRestaurantFood(id_restaurant);
    //   if (!this.food_array[city_id]) {
    //     this.food_array[city_id] = {};
    //     this.food_object[city_id] = {};
    //   }

    //   this.food_array[city_id][id_restaurant] = data.array;
    //   this.food_object[city_id][id_restaurant] = data.object;

    //   return data.array;
    // },

    async createBusiness(elements: any) {
      try {
        await addN(elements);
      } catch (error) {
        console.error(error);
      }
    },

    async createProduct(elements: any) {
      try {
        await addP(elements.platillo, elements.id_negocio);
      } catch (error) {
        console.error(error);
      }
    },
  },
});
